export default __webpack_public_path__ + "static/images/app-phone-77131c97e98920340e5c0e90b95cbfff.jpg";